export default __webpack_public_path__ + "static/media/icon-rock.476e90a9.svg";